module.exports = __webpack_public_path__ + "644bb1ec00c0716df8561c591f5a277e.svg";